/**
 * Configuratie per documenttype: welke extractie-keys mappen op welke dossier-paden.
 * Nieuwe velden toevoegen = config-regel toevoegen, geen code wijziging.
 */

export interface ExtractionFieldMapping {
	extractionKey: string;
	label: string;
	/** Pad in dossier versionData (relatief t.o.v. resolver root). Geen pad = informatief veld. */
	dossierPath?: string;
	/** Checkbox standaard UIT bij conflict */
	isRiskField?: boolean;
}

export interface ExtractionFieldConfig {
	fields: ExtractionFieldMapping[];
	resolverType: "customer" | "incomeEntry" | "object" | "financing";
}

export const extractionFieldConfigs: Record<string, ExtractionFieldConfig> = {
	loonstrook: {
		resolverType: "incomeEntry",
		fields: [
			{
				extractionKey: "Werkgever",
				label: "Werkgever",
				dossierPath: "employerName",
			},
			{
				extractionKey: "BrutoLoon",
				label: "Bruto loon",
				dossierPath: "grossSalary",
				isRiskField: true,
			},
			{
				extractionKey: "VakantieGeld",
				label: "Vakantiegeld",
				dossierPath: "vacationAllowance",
			},
			{
				extractionKey: "DertiendeMaand",
				label: "13e maand",
				dossierPath: "thirteenthMonth",
			},
			{ extractionKey: "Overwerk", label: "Overwerk", dossierPath: "overtime" },
			{
				extractionKey: "Provisie",
				label: "Provisie",
				dossierPath: "commission",
			},
			{
				extractionKey: "OnregelmatigheidsToeslag",
				label: "Onregelmatigheid",
				dossierPath: "irregularHoursAllowance",
			},
			{
				extractionKey: "EindejaarUitkering",
				label: "Eindejaarsuitkering",
				dossierPath: "yearEndBonus",
			},
			// Informatieve velden (geen dossierPath)
			{ extractionKey: "Werknemer", label: "Werknemer" },
			{ extractionKey: "Periode", label: "Periode" },
			{ extractionKey: "NettoLoon", label: "Netto loon" },
		],
	},
	// classificationLabel = "legitimatie" (backend extractionMatcher.ts)
	legitimatie: {
		resolverType: "customer",
		fields: [
			{
				extractionKey: "Voornamen",
				label: "Voornamen",
				dossierPath: "personDetails.firstName",
			},
			{
				extractionKey: "Voorletters",
				label: "Voorletters",
				dossierPath: "personDetails.initials",
			},
			{
				extractionKey: "Tussenvoegsel",
				label: "Tussenvoegsel",
				dossierPath: "personDetails.infix",
			},
			{
				extractionKey: "Achternaam",
				label: "Achternaam",
				dossierPath: "personDetails.lastName",
			},
			{
				extractionKey: "Geboortedatum",
				label: "Geboortedatum",
				dossierPath: "personDetails.birthDate",
				isRiskField: true,
			},
			{
				extractionKey: "Geslacht",
				label: "Geslacht",
				dossierPath: "personDetails.gender",
			},
			{
				extractionKey: "DocumentNummer",
				label: "Documentnummer",
				dossierPath: "identification.idNumber",
			},
			{
				extractionKey: "DatumAfgifte",
				label: "Datum afgifte",
				dossierPath: "identification.issueDate",
			},
			{
				extractionKey: "PlaatsAfgifte",
				label: "Plaats afgifte",
				dossierPath: "identification.issuePlace",
			},
			{
				extractionKey: "Nationaliteit",
				label: "Nationaliteit",
				dossierPath: "otherDetails.nationality",
			},
			{
				extractionKey: "Geboorteplaats",
				label: "Geboorteplaats",
				dossierPath: "otherDetails.birthPlace",
			},
			// Informatief
			{ extractionKey: "GeldigTot", label: "Geldig tot" },
			{ extractionKey: "BSN", label: "BSN" },
		],
	},
};
